<template>
  <dialog-add
    class="tracking-add-program-dialog"
    icon="link"
    :title="$t('new_program')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-tracking-program
        :on-cancel="onCancel"
        class="elevation-1"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push({
        name: 'tracking-management-advertiser',
        params: { id: this.$route.params.id },
      });
    },
  },
};
</script>

<style lang="scss">
.tracking-add-program-dialog {
  .dialog.add-item-dialog > .modal__backdrop > .modal__content {
    width: 692px;
  }
}
</style>
